var map = {
	"./cs-CZ.json": 1363,
	"./de-DE.json": 5006,
	"./en-US.json": 5381,
	"./es-ES.json": 9480,
	"./fr-FR.json": 9044,
	"./hu-HU.json": 4990,
	"./it-IT.json": 5038,
	"./ja-JP.json": 3933,
	"./ko-KR.json": 6303,
	"./pl-PL.json": 8136,
	"./pt-BR.json": 6040,
	"./pt-PT.json": 5496,
	"./ru-RU.json": 3229,
	"./zh-CN.json": 731,
	"./zh-TW.json": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9628;